import { ReactNode } from "react";
import Head from "next/head";

export function RobotIndexedPage({ children }: { children: ReactNode }) {
  return (
    <>
      <Head>
        <meta name="robots" content="index, nofollow" />
      </Head>
      {children}
    </>
  );
}
